import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import * as en from "@/src/common/locales/en";
import * as es from "@/src/common/locales/es";
import * as fr from "@/src/common/locales/fr";
import * as ptBR from "@/src/common/locales/pt-BR";

const resources = {
	en,
	es,
	fr,
	"pt-BR": ptBR,
};

export const LANGUAGES = {
	en: "English",
	es: "Español",
	fr: "Français",
	"pt-BR": "Português (Brasil)",
} as const;

export type Language = keyof typeof LANGUAGES;

export const NAMESPACES = {
	common: "common",
	auth: "auth",
	onboarding: "onboarding",
	community: "community",
	communityLink: "communityLink",
	email: "email",
	shell: "shell",
	post: "post",
	member: "member",
	group: "group",
	message: "message",
	meeting: "meeting",
	event: "event",
	notification: "notification",
	moderation: "moderation",
	admin: "admin",
	contact: "contact",
	legal: "legal",
	search: "search",
	staff: "staff",
	ai: "ai",
	externalInvitation: "externalInvitation",
};

export type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = "en";
export const DEFAULT_NAMESPACE: Namespace = "common";

use(initReactI18next).init({
	resources,
	ns: Object.values(NAMESPACES),
	defaultNS: DEFAULT_NAMESPACE,
	fallbackNS: DEFAULT_NAMESPACE,
	fallbackLng: DEFAULT_LANGUAGE,
	supportedLngs: Object.keys(LANGUAGES),
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: true,
	},
	nsSeparator: ":",
	keySeparator: ".",
	detection: {
		order: ["cookie", "navigator"],
		lookupCookie: "app-locale",
		caches: ["cookie"],
	},
});

export { default } from "i18next";
